import { render } from "./index.vue?vue&type=template&id=1c78249c&ts=true"
import script from "./index.ts?vue&type=script&lang=ts"
export * from "./index.ts?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__